import type { IntlShape } from 'react-intl';
import type { ToolUseItem } from '../../../../contracts/harness.types';

import {
  renderStandardExportToolUse,
  type OpenExportDocumentPayload,
} from './shared/exportDocumentPreview';

export const renderGenerateWordToolUse = (
  item: ToolUseItem,
  intl: IntlShape,
  onOpenDocumentExport?: (payload: OpenExportDocumentPayload) => void
): JSX.Element | null =>
  renderStandardExportToolUse(
    item,
    intl,
    {
      artefactType: 'word',
      titleFallback: { id: 'pjArtDoc04', defaultMessage: 'Word export' },
    },
    onOpenDocumentExport
  );
